/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowexample32Inputs */

const en_aiflowexample32 = /** @type {(inputs: Aiflowexample32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pub quiz on Thursday at 7 pm, free entry`)
};

const de_aiflowexample32 = /** @type {(inputs: Aiflowexample32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pub Quiz am Donnerstag um 19 Uhr, Eintritt frei`)
};

/**
* | output |
* | --- |
* | "Pub quiz on Thursday at 7 pm, free entry" |
*
* @param {Aiflowexample32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowexample32 = /** @type {((inputs?: Aiflowexample32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowexample32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowexample32(inputs)
	return de_aiflowexample32(inputs)
});
export { aiflowexample32 as "aiFlowExample3" }